import request from '@/utils/request'

export function getInvDetailBill(param) {
    let data = param
    return request({
        url: `/invoice/getInvDetailBill`,
        method: 'POST',
        meta: { apiVersion: '1.0.0' },
        headers: { 'Content-Type': 'application/json;charset=utf8' },
        data
    })
}

export function deleteNewBill(param) {
    let data = param
    return request({
        url: `/invoice/deleteNewBill`,
        method: 'POST',
        meta: { apiVersion: '1.0.0' },
        headers: { 'Content-Type': 'application/json;charset=utf8' },
        data
    })
}

export function makeNewBill(param) {
    let data = param
    return request({
        url: `/invoice/makeNewBill`,
        method: 'POST',
        meta: { apiVersion: '1.0.0' },
        headers: { 'Content-Type': 'application/json;charset=utf8' },
        data
    })
}

export function getPopUpList(param) {
    let data = param
    return request({
        url: `/invoice/getPopUpList`,
        method: 'POST',
        meta: { apiVersion: '1.0.0' },
        headers: { 'Content-Type': 'application/json;charset=utf8' },
        data
    })
}

export function getInvDetailAmt(param) {
    let data = param
    return request({
        url: `/invoice/getInvDetailAmt`,
        method: 'POST',
        meta: { apiVersion: '1.0.0' },
        headers: { 'Content-Type': 'application/json;charset=utf8' },
        data
    })
}

export function getFeeList(param) {
    let data = param
    return request({
        url: `/invoice/getFeeList`,
        method: 'POST',
        meta: { apiVersion: '1.0.0' },
        headers: { 'Content-Type': 'application/json;charset=utf8' },
        data
    })
}

export function deleteInvAmt(param) {
    let data = param
    return request({
        url: `/invoice/deleteInvAmt`,
        method: 'POST',
        meta: { apiVersion: '1.0.0' },
        headers: { 'Content-Type': 'application/json;charset=utf8' },
        data
    })
}

export function newInvAmt(param) {
    let data = param
    return request({
        url: `/invoice/newInvAmt`,
        method: 'POST',
        meta: { apiVersion: '1.0.0' },
        headers: { 'Content-Type': 'application/json;charset=utf8' },
        data
    })
}